import Vue from 'vue'
import Vuex from 'vuex'
import { router } from './router'
import { fluent } from './utils'

Vue.use(Vuex)

const bucketModule = {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    set(s, v) { s.list = v },
    update(s, v) { listItemUpdate(s.list, v) },
    remove(s, v) {
      let i = s.list.findIndex(e => e.id === v.id)
      if (i < 0) { return }
      s.list.splice(i, 1)
    }
  },
  getters: {
    get: (s) => (v) => {
      let bucket = s.list.find(e => e.id === v.id)
      if (bucket) return bucket
      Vue.store.dispatch('bucket/get', v)
    },
  },
  actions: {
    async list({ commit }) {
      let res = await Vue.request(Vue.api.bucket.list())
      //直接在此加入模型数据统计
      for(let bucket of res){
        if(bucket.size === undefined){
          bucket.size = '...'
          let model = await Vue.request(Vue.api.model.list({
            bucket: bucket.id,
            page: 0,
            size: 1
          }))
          bucket.size = model.total
        }
      }
      commit('set', res)
      return res
    },

    async add({ commit }, v) {
      let res = await Vue.request(Vue.api.bucket.add(v))
      commit('update', res)
      return res
    },

    async remove({ commit }, v) {
      await Vue.request(Vue.api.bucket.remove(v))
      commit('remove', v)
    },

    async update({ commit }, v) {
      let res = await Vue.request(Vue.api.bucket.update(v))
      commit('update', res)
      return res
    },

    async get({ commit }, v) {
      let res = await Vue.request(Vue.api.bucket.get(v))
      commit('update', res)
      return res
    },

    async size({ commit, state }, v) {
      let res = await Vue.request(Vue.api.model.list({
        bucket: v.id,
        page: 0,
        size: 1
      }))
      let bucket = state.list.find(e => e.id === v.id)
      commit('update', {...v, ...bucket, size: res.total})
      return res.total
    }
  }
}


const userModule = {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set(s, v) { s.list = v },
    update(s, v) { listItemUpdate(s.list, v) }
  },
  getters: {
    get: (s, g, rs, rg) => (v) => {
      let user = s.list.find(e => e.id === v.id)
      if (user) return user
      if (fluent(() => rs.me.id) === v.id) return rs.me
      Vue.store.dispatch('user/get', v)
    }
  },
  actions: {
    async list({ commit }) {
      let res = await Vue.request(Vue.api.user.list())
      commit('set', res)
      return res
    },

    async add({ commit }, v) {
      let res = await Vue.request(Vue.api.user.add(v))
      commit('update', res)
      return res
    },

    async update({ commit, rootState }, v) {
      let user = await Vue.request(Vue.api.user.update(v))

      commit('update', user)
      let { me } = rootState
      if (me && me.id === user.id) {
        commit('me', { ...me, ...user }, { root: true })
      }
      return user
    },

    async get({ commit, state, rootState }, v) {
      let user = await Vue.request(Vue.api.user.get(v))
      commit('update', user)
      return user
    },
  },
}

const departmentModule = {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set(s, v) { s.list = v },
    update(s, v) { listItemUpdate(s.list, v) },
    remove(s, v) { s.list.splice(s.list.findIndex(item=>item.id===v), 1)}
  },
  getters: {
    get: (s) => (v) => {
      let department = s.list.find(e => e.id === v.id)
      if (department) return department 
      else return '未知'
    },
    getNo: (s) => (v) => {
      let department = s.list.find(e => e.no === v.no)
      if (department) return department 
      else return '未知'
    }
  },
  actions: {
    async list({ commit }) {
      let res = await Vue.request(Vue.api.department.list())
      commit('set', res)
      return res
    },

    async remove({ commit }, v) {
      let res = await Vue.request(Vue.api.department.remove(v))
      commit('remove', res)
      return res
    },

    async add({ commit }, v) {
      let res = await Vue.request(Vue.api.department.add(v))
      commit('update', res)
      return res
    },

    async update({ commit }, v) {
      let department = await Vue.request(Vue.api.department.update(v))
      commit('update', department)
      return department
    },

    async get({ commit }, v) {
      let department = await Vue.request(Vue.api.department.get(v))
      return department
    },
  },
}


const computerModule = {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set(s, v) { s.list = v },
    update(s, v) { listItemUpdate(s.list, v) },
    remove(s, v) { s.list.splice(s.list.findIndex(item=>item.id===v), 1)}
  },
  getters: {
    get: (s) => (v) => {
      let computer = s.list.find(e => e.id === v.id)
      if (computer) { 
        return computer 
      }else{
        return '未知'
      }
    },
    getNo: (s) => (v) => {
      let computer = s.list.find(e => e.no === v.no)
      if (computer) return computer 
      else return '未知'
    }
  },
  actions: {
    async list({ commit }, v) {
      let res = await Vue.request(Vue.api.computer.list(v))
      commit('set', res)
      return res
    },

    async remove({ commit }, v) {
      let res = await Vue.request(Vue.api.computer.remove(v))
      commit('remove', res)
      return res
    },

    async add({ commit }, v) {
      let res = await Vue.request(Vue.api.computer.add(v))
      commit('update', res)
      return res
    },

    async update({ commit }, v) {
      let computer = await Vue.request(Vue.api.computer.update(v))
      commit('update', computer)
      return computer
    },

    async get({ commit }, v) {
      let computer = await Vue.request(Vue.api.computer.get(v))
      return computer
    },
  },
}


export const store = new Vuex.Store({
  modules: {
    department: departmentModule,
    user: userModule,
    bucket: bucketModule,
    computer: computerModule
  },
  state: {
    me: null
  },
  mutations: {
    me(s, v) { s.me = v },
  },
  getters: {
    anonymous: (s) => s.me === null,
    name: (s) => fluent(() => s.me.name || '未命名', '未登录'),
    admin: (s) => fluent(() => s.me.authorities.map(({ authority }) => authority).includes('admin'), false),
  },
  actions: {
    async logout({ commit, state }) {
      await Vue.request(Vue.api.user.logout())
      commit('me', null)
      commit('user/set', [])
      commit('bucket/set', [])
      router.push('/login?back')
    },

    async login({ commit }, v) {
      let res = await Vue.request(Vue.api.user.login(v))
      commit('me', res)
      if (router.currentRoute.query.back !== undefined) {
        router.go(-1)
      } else {
        // router.push('1vs1/detect')
        router.push('log/1v1')
      }
    },

    async me({ commit, state }) {
      let res = await Vue.request(Vue.api.user.me())
      commit('me', res || null)
      return res
    },
  }
})

const listItemUpdate = (list, value) => {
  for (const e of list) {
    if (e.id === value.id) {
      for (const [k, v] of Object.entries(value)) {
        e[k] = v
      }
      return
    }
  }
  list.push(value)
  list.sort((a, b) => a.id - b.id)
}
